import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n'
import './index.css'

export const getRender = (id = 'root') => {
  return ReactDOM.createRoot(document.getElementById(id))
}

const root = getRender('root')

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)
